var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-admin"},[_c('div',{staticClass:"layout-admin-body"},[_c('router-view')],1),_c('nav-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }